import { Transform } from 'class-transformer';

/**
 * Transforms empty strings to undefined.
 * Useful for optional string fields in DTOs where HTML forms
 * send empty strings instead of null/undefined.
 */
export function OptionalStringTransform(): PropertyDecorator {
  return Transform(({ value }) => {
    if (typeof value === 'string' && value.trim() === '') {
      return undefined;
    }
    return value;
  });
}
